module.exports = __webpack_public_path__ + "media/src/img/payment/sber-button-g-b-d8cd02155088181d4fff0c1761d16be8.svg";